import { ThunkDispatch } from "core-integration/src/store";
import { deleteLeague } from "core-integration/src/store/leagues/thunks";
import { IPrivateLeagueAdmin } from "core-integration/src/store/leagues/types";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Button from "../../Button";
import SubHeading from "../../SubHeading";
import { useNavigate } from "react-router";

interface IOwnProps {
  league: IPrivateLeagueAdmin;
}

type Props = IOwnProps & WithTranslation;

const Delete: React.FC<Props> = ({ league, t }) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const navigate = useNavigate();

  const remove = async (leagueId: number) => {
    if (window.confirm("Are you sure you want to delete this league?")) {
      await dispatch(deleteLeague(leagueId));
      navigate("/leagues");
    }
  };

  return (
    <>
      <SubHeading>{t("delete.title", "Delete league")}</SubHeading>
      <p>
        {t(
          "delete.description",
          "To delete the league, click on the button below. The players entered in the league will still exist and can enter other leagues if desired.",
        )}
      </p>
      <Button onClick={() => remove(league.id)}>
        {t("delete.cta", "Delete league")}
      </Button>
    </>
  );
};

export default withTranslation()(Delete);
